// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rx-c";
export var backButton = "_rx-4";
export var backIcon = "_rx-5";
export var chevronShortcut = "_rx-6";
export var container = "_rx-1";
export var editor = "_rx-8";
export var editorWrapper = "_rx-7";
export var prefix = "_rx-2";
export var searchIcon = "_rx-3";
export var suffix = "_rx-9";
export var suffixContent = "_rx-a";
export var suffixText = "_rx-b";
export var wrapper = "_rx-0";